import React, { forwardRef } from 'react';

// The stem and left leaf have the same final union as the original seedling path.
const BrandMark = forwardRef(function BrandMark({ className = '', ...props }, ref) {
  return <svg ref={ref} viewBox="0 0 512 512" fill="currentColor" focusable="false"
    aria-hidden="true" className={`rd-brand-leaf ${className}`.trim()} {...props}>
    <path className="rd-brand-leaf-stem"
      d="M224 300H288V480c0 17.7-14.3 32-32 32s-32-14.3-32-32Z" />
    <g className="rd-brand-leaf-left-idle">
      <path className="rd-brand-leaf-left"
        d="M0 96C0 78.3 14.3 64 32 64l32 0c123.7 0 224 100.3 224 224l0 32H224C100.3 320 0 219.7 0 96Z" />
    </g>
    <g className="rd-brand-leaf-right-idle">
      <path className="rd-brand-leaf-right"
        d="M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0l32 0c17.7 0 32 14.3 32 32z" />
    </g>
  </svg>;
});

export default BrandMark;
